// FIXME: remove after nuxtjs/supabase installed
import type { User } from '@supabase/supabase-js'

export const useSupabaseUser = (): Ref<User | null> => {
  return useState<User | null>('supabase_user')
}
